'use client';

import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerClose,
} from '@/components/ui/drawer';
import { useGetAgreement } from '@/features/auth/services/agreement';
import './index.css';
import { Spin } from '@/components/ui-feat/spin';
interface ModalTextProps {
  title?: string;
  onCancel?: () => void;
}

const ModalText = NiceModal.create<ModalTextProps>(({ title }) => {
  const modal = useModal();

  const { data, isLoading } = useGetAgreement.useQueryHook({ agreementType: '1' });
  return (
    <Drawer open={modal.visible} onOpenChange={(open) => !open && modal.hide()}>
      <DrawerContent className="bg-surface border-none rounded-t-[10px] text-white h-[80vh]">
        <DrawerHeader className="text-center px-[4px]">
          <DrawerClose asChild>
            <button className="absolute top-4 right-[11px] text-gray-400 hover:text-white">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </DrawerClose>
          <DrawerTitle className="text-white text-base font-medium">
            {title || ''}
          </DrawerTitle>
        </DrawerHeader>

        <div className="flex-1 overflow-y-auto px-[11px] pb-[25px]">
          <div className="prose prose-invert max-w-none userAgreement">
            {
              isLoading ? <Spin className="flex-1 h-full" /> :
                <div className="min-h-[300px] font-[Montserrat-SemiBold] text-tertiary" dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
            }
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
});

export default ModalText;